import React, {
  useState,
  useEffect,
} from "react";
import "./FileViewer.css";
import { Document, Page, pdfjs } from "react-pdf";
import axios from 'axios';
// import "react-pdf/dist/Page/AnnotationLayer.css";
import Spinner from "../../Components/Spinner/Spinner";

const FileViewer = (props) => {

  const s3prefix = 'https://platform-backend-files.s3-ap-southeast-2.amazonaws.com/'
  // const apiprefix = 'https://n35tl2czql.execute-api.ap-southeast-2.amazonaws.com/default/getfile?path='//Lambda getfile 
  const apiprefix = 'https://zps3crms67.execute-api.ap-southeast-2.amazonaws.com/default/getfile3?path='//Lambda getfile3
  const cut_length = apiprefix.length
  const s3suffix = '_wm.pdf'

  const attempts = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19]
  // const [ispdf, setIspdf] = useState(true);
  // const [fileready, setfileready] = useState(true);
  const [fails, countFailure] = useState(0)
  // const fileurl = window.location.search.substring(1).split("fileurl=")[1];

  // const [fileurl, seturl] = useState(props.location.fileurl);
  // const [s3url, sets3url] = useState(s3prefix + (fileurl ? fileurl.substring(cut_length, fileurl.length) : "") + s3suffix)
  const fileurl = props.location.fileurl;
  
  const s3url = s3prefix + (fileurl ? fileurl.substring(cut_length, fileurl.length) : "") + s3suffix
  console.log("fileURL: ", fileurl, s3url)

  const [noPages, setNoPages] = useState();

  useEffect(() => {
    // console.log(fileurl)
    // console.log(s3url)
    pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  }, []);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNoPages(numPages);
  };

  const create_wm = () => {

    setTimeout(() => {
      var count = fails + 1
      countFailure(count)
      // sets3url(s3url);
    }, 10000);
  }

  /**
   * Please do read the following to understand the idea why the logic is implemented as following:
   *
   * [Brief Explaination]
   * The logic is a combination of:
   * A) If I save files with watermark(wm) on AWS, I should be able to request them the next time, without distubing the watermark function.
   *    So I try to access wm files first, if failed (there is not a wm file), request the wm function to generate one
   * B) If I am requesting wm function and failed for the first time (typically due to timeout) but the wm function is running in the backend
   *    and will generate my file after several time, I should attempt to get the generated file after some time, and attempt again if failed,
   *    because the file may still be under building.
   *
   * FACT: due to some API mismatch (in the node packages we can't modify), accessing the wm function will trigger the file generation but fail
   *       the react-pdf viewer for sure, in the second case of A) we can't simply request wm once, but need to do what is describe in B)
   *
   *
   *
   * [Detailed Explaination]
   * 1. The user upload their files without watermark;
   * 2. We invoke the wm function on AWS Lambda via <fileurl> to apply watermark on these file, and store the generated file under <s3url> for
   *    future use;
   * 3. Therefore, <fileurl> should be only invoked once when and only when <s3url> is empty, therefore we have the initial logic:
   *
   *    Try to invoke <s3url> first (attempt 0),
   *      If it works (onloadsuccess), then show the PDF,
   *      Otherwise (onloaderror), try to invoke <fileurl> (attempt 1)
   *
   * 4. Ideally, the wm function should return <s3url> on the original request, and redirect react-pdf Document to reuest <s3url>, but this is
   *    not achieved due to some interface mismatch, i.e. react-pdf will not auto retry the returned url from the python function;
   * 5. Moreover, it takes some time for the wm function to work on lambda, but the response does not always wait until the watermark function
   *    finishes, (one typical case is timeout in 30 seconds),
   * 6. However, the wm function is still running even after the timeout exception, and we can actually retrieve the file via <s3url> afterwards,
   *    this is why we set up a timeout (spleep function) and makes several more attempts (attempt 2 - 9) since we are sure if the python goes
   *    well, we will finially retrieve the file via <s3url>, and thus, we yield the following logic:
   *
   *    Try to invoke <s3url> first (attempt 0),
   *    If it works (onloadsuccess), then show the PDF,
   *    Otherwise (onloaderror), try to invoke <fileurl> (attempt 1)
   *    (Attempt 1 will trigger wm function but will always fail in terms of request)
   *    Wait 10 seconds and try to query <s3url> several times after attempt 1, with 10 seconds lag between every two
   *    Halt and show pdf on any success, or yielf a failure eventually after attempt 9 (which means there is something wrong with the file itself)
   *
   */

  const message = (type) => {
    return <div className="fv-spinner-container">
      <div>
        {type === "loading" &&
          <>
            {fails === 0 && <div>Loading file with watermark...</div>}
            {fails > 0 && <div>Trying again to load file...</div>}
            <Spinner small />
          </>
        }
        {type === "fileerror" &&
          "Could not load the requested file."
        }
        {type === "nodata" &&
          "No PDF file specified."
        }
      </div>
    </div>
  }

  return (
    <div>
      {
        attempts.map((index) => {
          const fileUrlToLoad = fails === 1 || fails === 19 ? fileurl : s3url
          console.log("Load at: ", index, fileUrlToLoad)
          return (
            (fails === index && fails < 1) ? (
              <Document
                className="prevent-print file-viewer-document"
                id="doc"
                // *** please read the logic instruction above to understand why index === 1 is used here
                // file={(index === 1) ? fileurl : s3url}
                file={fileurl}
                loading={() => message("loading")}
                onLoadSuccess={onDocumentLoadSuccess}
                onLoadError={create_wm}
                // error={<div>Failed loading the PDF.
                //     {(index === 0) ? "This often happens when you try to access a newly uploaded file, because we are applying water mark on it.\n" : ""}
                //     The system will attempt to load it again in 10 seconds</div>}
                error={() => message("loading")}
                noData={() => message("nodata")}
                renderMode="pdf"
              >
                {/* <Page pageNumber={1} /> */}
                {Array.from(
                  new Array(noPages),
                  (el, index) => (
                    <div className="file-viewer-page-container">
                      <Page
                        width="800"
                        key={`page_${index + 1}`}
                        pageNumber={index + 1}
                      />
                    </div>
                  ),
                )}
                {/* {page(noPages)} */}
              </Document>
            ) : (
              fails === index && (
                <div class="container text-center my-3">
                  <img src={fileUrlToLoad} style={{display: 'inline-block'}} />
                </div>
              )
              
            )
          )
        })
      }

      {/* { (ispdf && !fileready) && ( */}
      { (fails >= 6) && (
        // <div className='center'>
        //   There is some thing wrong with the doc, and the system cannot load the file requested.
        // </div>
        message("fileerror")
      )}
    </div>

  )
}

export default FileViewer
